module.exports = __webpack_public_path__ + "img/2.4684574c.png";